import UdeskLocales from 'UdeskLocales';
import React, { useCallback, useMemo } from 'react';

export const PadOne = ({ title, data, inspectDataSource }) => {
    const locales = UdeskLocales['current'];

    const getCount = useCallback((count?: number) => {
        return count && count > 9999 ? `${(count / 1000).toFixed(1)}K` : `${count || 0}`;
    }, []);

    const count = useMemo(() => {
        return inspectDataSource === 1
            ? getCount(data.qa_inspection_generic__call_count)
            : inspectDataSource === 2
            ? getCount(data.qa_inspection_generic__dialog_count)
            : inspectDataSource === 20
            ? getCount(data.qa_inspection_generic__survey_count)
            : inspectDataSource === 10
            ? getCount(data.qa_inspection_generic__ticket_count)
            : inspectDataSource === 8
            ? getCount(data.qa_inspection_generic__mall_count)
            : null;
    }, [
        data.qa_inspection_generic__call_count,
        data.qa_inspection_generic__dialog_count,
        data.qa_inspection_generic__mall_count,
        data.qa_inspection_generic__survey_count,
        data.qa_inspection_generic__ticket_count,
        getCount,
        inspectDataSource,
    ]);

    return (
        <div className="general-inspection-report-page-data-list-info">
            <div className="general-inspection-report-page-data-list-info-left">
                <h2>{title}</h2>
                <div>{count}</div>
            </div>
            <div className="general-inspection-report-page-data-list-info-right">
                <h2>{locales.fix.intelligentQualityInspection}</h2>
                <div>
                    {data.qa_inspection_generic__total_inspection_count > 9999
                        ? `${(data.qa_inspection_generic__total_inspection_count / 1000).toFixed(
                              1
                          )}K`
                        : `${data.qa_inspection_generic__total_inspection_count}`}
                </div>
                <p>
                    {locales.fix.percentage}：
                    <span>{data.qa_inspection_generic__total_inspection_rate}</span>
                </p>
            </div>
            <div className="general-inspection-report-page-data-list-info-right">
                <h2>{locales.fix.artificialSampling}</h2>
                <div>
                    {data.qa_inspection_generic__extraction_count > 9999
                        ? `${(data.qa_inspection_generic__extraction_count / 1000).toFixed(1)}K`
                        : `${data.qa_inspection_generic__extraction_count}`}
                </div>
                <p>
                    {locales.fix.percentage}：
                    <span>{data.qa_inspection_generic__extraction_rate}</span>
                </p>
            </div>
            <div className="general-inspection-report-page-data-list-info-right">
                <h2>{locales.fix.appealNumber}</h2>
                <div>
                    {data.qa_inspection_generic__appeal_count > 9999
                        ? `${(data.qa_inspection_generic__appeal_count / 1000).toFixed(1)}K`
                        : `${data.qa_inspection_generic__appeal_count}`}
                </div>
                <p>
                    {locales.fix.percentage}：<span>{data.qa_inspection_generic__appeal_rate}</span>
                </p>
            </div>
            <div className="general-inspection-report-page-data-list-info-right">
                <h2>{locales.fix.samplingReviewRate}</h2>
                <div>{data.qa_inspection_generic__manual_check_rate}</div>
            </div>
        </div>
    );
};
